import React from "react";
import { useAuth } from "./useAuth";
import { Navigate, Outlet } from "react-router-dom";
import Loader from "../components/Loader";
import useRole from "./useRole";

const SuperAdminAccess = () => {
  const { isSuperAdmin, role } = useRole();
  console.log(isSuperAdmin, role, "isSuperAdmin in SuperAdminAccess");

  return !isSuperAdmin ? <Navigate to="/unauthorized" replace /> : <Outlet />;
};

export default SuperAdminAccess;
